export default {  
    computed: {

        status() {
            const status = this.ticket.status

            switch(status) {
                case 'OPEN': 
                    return {
                        name: this.$t(`support.tickets.situation.${status}`),
                        icon: 'fas fa-circle',
                        action: 'fas fa-reply',
                        class: 'text-primary'
                    }
                case 'WAITING_STUDENT':
                    return {
                        name: this.$t(`support.tickets.situation.${status}`),
                        icon: 'fas fa-circle',
                        action: 'fas fa-reply',
                        class: 'text-warning'
                    }
                case 'WAITING_OP':
                    return {
                        name: this.$t(`support.tickets.situation.${status}`),
                        icon: 'fas fa-circle',
                        action: 'fas fa-reply',
                        class: 'text-info'
                    }
                case 'CLOSED':
                    return {
                        name: this.$t(`support.tickets.situation.${status}`),
                        icon: 'fas fa-circle',
                        action: 'fas fa-eye',
                        class: 'text-danger'
                    }
                case 'RESOLVED':
                    return {
                        name: this.$t(`support.tickets.situation.${status}`),
                        icon: 'fas fa-circle',
                        action: 'fas fa-eye',
                        class: 'text-success'
                    }
                case 'IN_PROCESS':
                    return {
                        name: this.$t(`support.tickets.situation.${status}`),
                        icon: 'fas fa-circle',
                        action: 'fas fa-reply',
                        class: 'text-default'
                    }
            }
        }
    }
}